
// SVG Icon: switch-on
export default { id: "terriajs-switch-on" };
export const id = "terriajs-switch-on";
export const name = "switch-on";
